import { Outlet } from 'react-router-dom';

import { Image } from '@codes/ui-kit/components/ui/image';
import { ToggleOption } from '@web/app/shared/components/ToggleOption';

import { CodesLogoImage } from '@codes/assets';

export const PublicLayout = () => {
    return (
        <div className="bg-background w-full min-h-screen flex flex-col">
            {/* Header */}
            <header className="sticky top-0 z-[99] bg-background/80 backdrop-blur-lg border-b border-divider">
                <div className="max-w-6xl mx-auto flex items-center justify-between h-14 px-8 lg:px-12">
                    <a href="/" className="transition-opacity hover:opacity-70">
                        <Image src={CodesLogoImage} alt="Eureka Codes" className="h-[22px]" />
                    </a>
                    <div className="flex items-center scale-[0.8] origin-right">
                        <ToggleOption />
                    </div>
                </div>
            </header>

            {/* Content */}
            <main className="flex-1">
                <Outlet />
            </main>

            {/* Footer */}
            <footer className="border-t border-divider py-6">
                <div className="max-w-6xl mx-auto px-8 lg:px-12 flex items-center justify-between text-xs text-placeholder">
                    <span>&copy; {new Date().getFullYear()} LemonCloud</span>
                    <a href="/" className="hover:text-sub transition-colors">
                        Eureka Codes
                    </a>
                </div>
            </footer>
        </div>
    );
};
